




















































































import Vue from 'vue'
import { parseMap, convertSeconds, isDisplayShow } from '@/utils/index'
import { planStatusMap, planStatusMapColor, planCategoryMap } from '@/utils/commonDef'
import dayjs from 'dayjs'
import { ProductionStatisticsServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
import { TenantBizFieldServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
const productionStatisticsServiceProxy = new ProductionStatisticsServiceProxy()
const tenantBizFieldServiceProxy = new TenantBizFieldServiceProxy()
import AdvancedSearch from '@/components/AdvancedSearch'
import { exportOverdue } from '@/api/api'

export default Vue.extend({
  name: '',
  components: {
    AdvancedSearch
  },
  data() {
    return {
      data: [],
      loading: false,
      pageSize: 30,
      currentPage: 1,
      searchDto: {
        typeId: '',
        filterPlus: false,
        planStatus: ['1', '2', '3', '4'],
        param: {}
      },
      planStatusMap,
      planStatusMapColor,
      planStatusList: parseMap(planStatusMap),
      selectedRowKeys: [],
      currentPlan: null,
      customRow: (record) => {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self: any = this
        return {
          on: {
            click: (e) => {
              self.currentPlan = { ...record }
              self.selectedRowKeys = [self.currentPlan.id]
            }
          }
        }
      },
      planCategoryMap,
      totalContent: 0, // 表格总数
      productColums: [], // 产品表格的字段
      showColumns: [],
      tableScrollWidth: 1700,
      isLoadComplete: false,
      tableScrollHeight: 650,
      selectArr: [],
      defaultSelect: {}
    }
  },
  created() {
    this.getSelectArr();
    this.getTableColumn()
    this.load()
  },
  updated() {
    this.tableScrollHeight = document.querySelector('#main-page').clientHeight - 134
    console.log(this.tableScrollHeight)
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys }: any = this
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys: [], selectedRows: []) => {
          this.selectedRowKeys = selectedRowKeys
          if (this.selectedRowKeys.length === 1) {
            this.currentPlan = this.data.find((res) => res.id === this.selectedRowKeys[0]) || {}
          }
        },
        getCheckboxProps(record) {
          return ({
            style: {
              display: record.id ? 'block' : 'none'
            },
            props: {
              disabled: record.id ? false: true
            }
          })
        }
      }
    },
    hasSelected() {
      return this.selectedRowKeys.length > 0
    },
    exportFn() {
      const params = {
        bizCode: 'stat_overdue_plan',
        bizDataId: this.searchDto.typeId,
        current: this.currentPage,
        size: this.pageSize,
        tenantId: ''
      }
      return exportOverdue.bind(this, this.searchDto, params)
    },
  },
  watch: {
    'searchDto.planStatus'() {
      this.load()
    }
  },
  methods: {
    cancelChooseArr(val) {
      this.selectedRowKeys = [];
    },
    getSelectArr() {
      let arr = JSON.parse(localStorage.getItem('coproduction'));
      let  arrX = [];

      for(var i=0; i<arr.length; i++) {
        let obj = {
          label: arr[i].name,
          value: arr[i].id
        }
        arrX.push(obj)
      }
      this.selectArr = arrX;

      this.defaultSelect = {
        key: arr[0].id,
        label: arr[0].name
      }
      this.searchDto.typeId = arr[0].id;

    },
    changeProduction(e) {
      console.log(e);
      this.searchDto.typeId = e.key.toString()
      this.getTableColumn()
      this.load()  
    },
    showStatusColor(value) {
      const status = this.searchDto.planStatus.find((res) => res == value)
      let color = ''
      if (status) {
        color = this.planStatusMapColor[value]
      }
      return color
    },
    inSearchStatus(value) {
      // console.log(value)
      const status = this.searchDto.planStatus.find((res) => res == value)
      let boolean = false
      if (status) {
        boolean = true
      }
      return boolean
    },
    inputStatus(value) {
      const newTags = [...this.searchDto.planStatus]
      const status = this.searchDto.planStatus.find((res) => res == value)
      if (!status) {
        this.searchDto.planStatus.push(value)
      } else {
        this.searchDto.planStatus = newTags.filter((res) => res != value)
      }
    },
    reload(data) {
      this.searchDto.filterPlus = true
      this.searchDto.param = data
      this.currentPage = 1
      this.$nextTick(() => this.load())
    },
    load() {
      this.selectedRowKeys = []
      this.loading = true
      productionStatisticsServiceProxy
        .getProductionPlanOverdueAnalysis(this.currentPage, this.searchDto, this.pageSize)
        .then((res) => {
          console.log('aaaaaaa',res)
          this.loading = false
          this.isLoadComplete = true
          this.data = []
          if (res.records.length > 0) {
            this.currentPlan = res.records[0]
            this.selectedRowKeys = [this.currentPlan.id]
            this.totalContent = res.total
            res.records.forEach((res: any) => {
              res.planEndTime = this.covertTime(res.planEndTime, false)
              res.planStartTime = this.covertTime(res.planStartTime, false)
              res.endTime = this.covertTime(res.endTime, true)
              res.startTime = this.covertTime(res.startTime, true)
              res.forecastEndTime = this.covertTime(res.forecastEndTime, true)
              res.forecastOverdueDuration = convertSeconds(res.forecastOverdueDuration)
              res.overdueDuration = convertSeconds(res.overdueDuration)
            })
            this.data = res.records

            let dataLength = res.records.length;
            let copy =res.records;
            let needPush = 0;
            if(dataLength < 30) {
              needPush = 30 - dataLength;
              for(var k=0; k<needPush; k++) {
                let obj:any = {  
                  planEndTime: null,
                  planStartTime: null,
                  endTime: null,
                  startTime: null,
                  forecastEndTime: null
                }
                copy.push(obj)  
              }
            }
            this.data = copy;
            console.log(this.data,'aaaaaaa')

          } 
          else {
            this.totalContent = 0
            this.data = [];

            let dataLength = this.data.length;
            let copy = this.data;
            let needPush = 0;
            if(dataLength < 30) {
              needPush = 30 - dataLength;
              for(var k=0; k<needPush; k++) {
                let obj = {  
                  planEndTime: null,
                  planStartTime: null,
                  endTime: null,
                  startTime: null,
                  forecastEndTime: null
                }
                copy.push(obj)  
              }
            }
            this.data = copy;
            this.loading = false

            console.log(this.data,'bbbbbbb')
          }
        })
        .catch((err) => {
          this.loading = false
          this.data = [];
          let dataLength = this.data.length;
            let copy = this.data;
            let needPush = 0;
            if(dataLength < 30) {
              needPush = 30 - dataLength;
              for(var k=0; k<needPush; k++) {
                let obj = {  
                  planEndTime: null,
                  planStartTime: null,
                  endTime: null,
                  startTime: null,
                  forecastEndTime: null
                }
                copy.push(obj)  
              }
            }
            this.data = copy;
            console.log(this.data,'ccccccc',err)
        })
        console.log(this.data)
    },
    //转换时间
    // flag为true 保留时分秒
    covertTime(time, flag) {
      if (time) {
        if (flag) {
          return dayjs(time).format('YYYY-MM-DD HH:mm:ss') || ''
        }
        return dayjs(time).format('YYYY-MM-DD') || ''
      }
      return ''
    },
    pageIndexchange(currentPage) {
      this.currentPage = currentPage
      this.load()
    },
    // 获取指定业务的字段列表
    async getTableColumn() {
      this.productColums = []
      this.productColums = await tenantBizFieldServiceProxy.getTenantBizField(
        'stat_overdue_plan',
        this.searchDto.typeId
      )
      this.handleColumns()
    },
    handleColumns() {
      this.showColumns = []
      if (!this.productColums || !this.productColums.length) {
        return
      }
      // 字段排序
      this.productColums.sort((a, b) => {
        return a.sort - b.sort
      })
      // 字段显隐
      let columns = []
      const timeArr = ['planStartTime', 'planEndTime', 'startTime', 'endTime', 'forecastEndTime']
      this.productColums.map((item) => {
        if (isDisplayShow(item.isDisplay, 2)) {
          // 自定义字段：产品类型
          const temp: any = {
            title: item.title,
            key: item.code,
            dataIndex: item.code,
            ellipsis: true
          }
          if (temp.key === 'code') {
            temp.width = 140
          } else if (timeArr.includes(temp.key)) {
            temp.width = 150
          } else {
            temp.width = (temp.title.length + 1) * 20
          }
          columns.push(temp)
        }
      })
      this.showColumns = [...columns]
      let num = this.productColums.filter((item) => isDisplayShow(item.isDisplay, 2)).length
      this.tableScrollWidth = num * 100
      console.log('showColumns:', this.showColumns)
    },
    totalFanyi(number: any) {
      const total = this.$t('Total…items')
      return total.replace('{0}', number)
    }
  }
})
